import { useQueryClient } from '@tanstack/react-query';
import { useCompany } from '@/contexts/CompanyContext';
import { useEffect } from 'react';

/**
 * Hook to manage React Query cache invalidation when switching companies
 */
export const useCompanyAwareQueries = () => {
  const { currentCompany } = useCompany();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (currentCompany?.company_id) {
      console.log('Company switched - clearing all cached data for multi-tenant isolation');
      
      // Clear all queries to ensure fresh data for the new company
      queryClient.clear();
      
      // Specifically invalidate company-related queries with proper query keys
      queryClient.invalidateQueries({ queryKey: ['recruitment-candidates'] });
      queryClient.invalidateQueries({ queryKey: ['admin-data'] });
      queryClient.invalidateQueries({ queryKey: ['ideal-profiles'] });
      queryClient.invalidateQueries({ queryKey: ['org-charts'] });
      queryClient.invalidateQueries({ queryKey: ['departments'] });
      queryClient.invalidateQueries({ queryKey: ['survey-submissions'] });
      queryClient.invalidateQueries({ queryKey: ['work-behavior'] });
      queryClient.invalidateQueries({ queryKey: ['user-management'] });
      queryClient.invalidateQueries({ queryKey: ['company-invitations'] });
    }
  }, [currentCompany?.company_id, queryClient]);

  return {
    clearCompanyData: () => {
      console.log('Manually clearing company-specific data');
      queryClient.clear();
    }
  };
};